import { Breakpoint, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from "@mui/material";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";

import "../../styles/dialogSkeleton.sass";

interface IDialogSkeletonProps {
    show: boolean;
    onClose: () => void;
    onDialogActionButtonClick: () => void;
    dialogTitle: string;
    dialogActionButtonLabel: string;
    disableActionButton?: boolean;
    dialogActionButtonClassName?: string;
    dialogPaperClassName?: string;
    maxWidth?: false | Breakpoint;
    dialogContentClassName?: string;
}

const DialogSkeleton: React.FC<IDialogSkeletonProps> = ({
    show,
    onClose,
    onDialogActionButtonClick,
    dialogTitle,
    dialogActionButtonLabel,
    disableActionButton = false,
    dialogActionButtonClassName,
    dialogPaperClassName,
    maxWidth = false,
    dialogContentClassName,
    children
}) => {
    const getDialogHeader = (): JSX.Element =>
        <DialogTitle className="dialog-skeleton-title">
            <div className="dialog-skeleton-title-div">
                {dialogTitle}
                <IconButton onClick={onClose} size="medium" edge="end">
                    <CloseIcon />
                </IconButton>
            </div>
        </DialogTitle>;

    const getDialogFooter = (): JSX.Element =>
        <DialogActions>
            <Button variant="text" onClick={onClose}>Cancel</Button>
            <Button
                variant="contained"
                color="primary"
                disabled={disableActionButton}
                onClick={onDialogActionButtonClick}
                className={dialogActionButtonClassName}
            >
                {dialogActionButtonLabel}
            </Button>
        </DialogActions>;

    return <Dialog
        open={show}
        maxWidth={maxWidth}
        scroll="paper"
        onClose={onClose}
        classes={{ paper: dialogPaperClassName }}
    >
        {getDialogHeader()}
        <DialogContent className={dialogContentClassName ?? "shortcuts-dialog-content"}>
            {children}
        </DialogContent>
        {getDialogFooter()}
    </Dialog>;
};

export default DialogSkeleton;
